export default __webpack_public_path__ + "static/media/ps_single-1.509f39e1.jpg";